module.exports = __webpack_public_path__ + "img/invoice.04e9204c.png";